/**
 * @generated SignedSource<<8f4d96cc4e88eb8791406fb1eb37b184>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type datalevel = "CJIS" | "EXTERNAL" | "INTERNAL" | "PRESALE" | "SECRET" | "TRIAL" | "UNKNOWN" | "%future added value";
export type TeamViewQuery$variables = {
  count: number;
  cursor?: string | null;
  loginOverriden?: boolean | null;
  loginTypes?: ReadonlyArray<string | null> | null;
  orgUuid: string;
  resourceGroupIds?: ReadonlyArray<string | null> | null;
  resourceGroupPermissions?: ReadonlyArray<string | null> | null;
  role?: string | null;
  userUuid?: any | null;
};
export type TeamViewQuery$data = {
  readonly organization: {
    readonly dataLevel: datalevel;
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"LoginTypeFilter_orgIdps" | "OrgLoginMethods_loginMethods" | "SsoProviderLoginTypeSelection_idpData" | "TeamView_identityProviderFragment" | "TeamView_organization">;
  } | null;
};
export type TeamViewQuery = {
  response: TeamViewQuery$data;
  variables: TeamViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginOverriden"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginTypes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgUuid"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceGroupIds"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceGroupPermissions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "role"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userUuid"
},
v9 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "orgUuid"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "kind": "Variable",
  "name": "loginOverriden",
  "variableName": "loginOverriden"
},
v12 = {
  "kind": "Variable",
  "name": "loginTypes",
  "variableName": "loginTypes"
},
v13 = {
  "kind": "Variable",
  "name": "resourceGroupIds",
  "variableName": "resourceGroupIds"
},
v14 = {
  "kind": "Variable",
  "name": "resourceGroupPermissions",
  "variableName": "resourceGroupPermissions"
},
v15 = {
  "kind": "Variable",
  "name": "role",
  "variableName": "role"
},
v16 = {
  "kind": "Variable",
  "name": "uuid",
  "variableName": "userUuid"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataLevel",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authEnabled",
  "storageKey": null
},
v25 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "samlAcsUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "samlMetadataUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcCallbackUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcInitiateLoginUrl",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcClientId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcIssuer",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oidcUsePkce",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "axonConnectDomain",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TeamView_organization"
          },
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamView_identityProviderFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SsoProviderLoginTypeSelection_idpData"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LoginTypeFilter_orgIdps"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrgLoginMethods_loginMethods"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v19/*: any*/),
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "users",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiry",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "organizationPermission",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LoginTypes",
                        "kind": "LinkedField",
                        "name": "supportedLoginOptions",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IdentityProviderConfiguration",
                            "kind": "LinkedField",
                            "name": "identityProviderConfiguration",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v23/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LoginTypesConnection",
                        "kind": "LinkedField",
                        "name": "loginTypes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LoginTypesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoginTypes",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IdentityProviderConfiguration",
                                    "kind": "LinkedField",
                                    "name": "identityProviderConfiguration",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v18/*: any*/),
                                      (v23/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "loginTypesOverriden",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "organizationNotes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserResourceGroupLinkConnection",
                        "kind": "LinkedField",
                        "name": "resourceGroupLinks",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserResourceGroupLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserResourceGroupLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "resourceGroupId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "resourceGroupName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "resourceGroupPermission",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v19/*: any*/),
            "filters": [
              "uuid",
              "role",
              "resourceGroupIds",
              "resourceGroupPermissions",
              "loginTypes",
              "loginOverriden"
            ],
            "handle": "connection",
            "key": "TeamView_users",
            "kind": "LinkedHandle",
            "name": "users"
          },
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IdentityProviderConfigurationConnection",
            "kind": "LinkedField",
            "name": "identityProviderConfigurations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentityProviderConfigurationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdentityProviderConfiguration",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v20/*: any*/),
                      (v18/*: any*/),
                      (v23/*: any*/),
                      (v21/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orgDefault",
                "value": true
              }
            ],
            "concreteType": "LoginTypesConnection",
            "kind": "LinkedField",
            "name": "loginTypes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LoginTypesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LoginTypes",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdentityProviderConfiguration",
                        "kind": "LinkedField",
                        "name": "identityProviderConfiguration",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v20/*: any*/),
                          (v18/*: any*/),
                          (v23/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "loginTypes(orgDefault:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LoginOverrideCount",
            "kind": "LinkedField",
            "name": "loginOverrideCounts",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e969fd0dc17754f3ac4d2fc9c4b892af",
    "id": null,
    "metadata": {},
    "name": "TeamViewQuery",
    "operationKind": "query",
    "text": "query TeamViewQuery(\n  $count: Int!\n  $cursor: String\n  $orgUuid: String!\n  $userUuid: UUID\n  $role: String\n  $resourceGroupIds: [String]\n  $resourceGroupPermissions: [String]\n  $loginTypes: [String]\n  $loginOverriden: Boolean\n) {\n  organization(uuid: $orgUuid) {\n    id\n    ...TeamView_organization_27YNIC\n    dataLevel\n    name\n    ...TeamView_identityProviderFragment\n    ...SsoProviderLoginTypeSelection_idpData\n    ...LoginTypeFilter_orgIdps\n    ...OrgLoginMethods_loginMethods\n  }\n}\n\nfragment LoginTypeFilter_orgIdps on Organization {\n  identityProviderConfigurations {\n    edges {\n      node {\n        uuid\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment OrgLoginMethods_loginMethods on Organization {\n  id\n  loginOverrideCounts {\n    loginType\n    key\n    displayName\n    count\n  }\n  identityProviderConfigurations {\n    edges {\n      node {\n        id\n        uuid\n        name\n        displayName\n        providerType\n        samlAcsUrl\n        samlMetadataUrl\n        oidcCallbackUrl\n        oidcInitiateLoginUrl\n        oidcClientId\n        oidcIssuer\n        oidcUsePkce\n        axonConnectDomain\n      }\n    }\n  }\n  loginTypes(orgDefault: true) {\n    edges {\n      node {\n        loginType\n        authEnabled\n        identityProviderConfiguration {\n          id\n          uuid\n          name\n          providerType\n          samlAcsUrl\n          samlMetadataUrl\n          oidcCallbackUrl\n          oidcInitiateLoginUrl\n          oidcClientId\n          oidcIssuer\n          oidcUsePkce\n          axonConnectDomain\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment SsoProviderLoginTypeSelection_idpData on Organization {\n  identityProviderConfigurations {\n    edges {\n      node {\n        id\n        uuid\n        name\n        providerType\n      }\n    }\n  }\n  loginTypes(orgDefault: true) {\n    edges {\n      node {\n        loginType\n        authEnabled\n        identityProviderConfiguration {\n          id\n          uuid\n          name\n          providerType\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TeamView_identityProviderFragment on Organization {\n  identityProviderConfigurations {\n    edges {\n      node {\n        id\n        uuid\n        name\n        providerType\n      }\n    }\n  }\n}\n\nfragment TeamView_organization_27YNIC on Organization {\n  id\n  users(uuid: $userUuid, role: $role, resourceGroupIds: $resourceGroupIds, resourceGroupPermissions: $resourceGroupPermissions, loginTypes: $loginTypes, loginOverriden: $loginOverriden, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        email\n        uuid\n        displayName\n        firstName\n        lastName\n        phoneNumber\n        expiry\n        organizationPermission\n        supportedLoginOptions {\n          loginType\n          identityProviderConfiguration {\n            name\n            providerType\n            id\n          }\n          id\n        }\n        loginTypes {\n          edges {\n            node {\n              loginType\n              authEnabled\n              identityProviderConfiguration {\n                id\n                name\n                providerType\n                uuid\n              }\n              id\n            }\n          }\n        }\n        ...UserProfile_loginTypes\n        loginTypesOverriden\n        resourceGroupLinks {\n          edges {\n            node {\n              id\n              resourceGroupId\n              resourceGroupName\n              resourceGroupPermission\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserProfile_loginTypes on User {\n  id\n  uuid\n  email\n  firstName\n  lastName\n  organizationPermission\n  loginTypesOverriden\n  phoneNumber\n  expiry\n  organizationNotes\n  resourceGroupLinks {\n    edges {\n      node {\n        resourceGroupId\n        resourceGroupName\n        resourceGroupPermission\n        id\n      }\n    }\n  }\n  loginTypes {\n    edges {\n      node {\n        loginType\n        authEnabled\n        identityProviderConfiguration {\n          id\n          name\n          providerType\n          uuid\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0a2a86b5d6c3b955b29939acc0bb1fa";

export default node;
